export default {
    app: {
        name: 'BZUCO Inspector',
        reseted: 'Ulaznice resetirane...',
        networkError: 'Greška poslužitelja, molimo provjerite internetsku vezu...',
        networkNotAvailable: 'Nije povezano'
    },
    menu: {
        test: 'Test čitača kodova',
        settings: 'Postavke',
        admin: 'Administracija',
        resetTickets: 'Resetiraj ulaznice',
        resetState: 'Resetiraj stanje aplikacije',
        logout: 'Odjava'
    },
    home: {
        login: 'Prijavi se',
        lastEvent: 'Provjeri zadnji događaj / zonu',
        lastEvents: 'Provjeri zadnje<br />učitane događaje',
        lastZones: 'Provjeri zadnje<br />učitane zone',
        chooseEvent: 'Odaberi događaj',
        checkEvents: 'Provjeri<br />događaje',
        checkZones: 'Provjeri<br />zone',
        scanConfig: 'Scan QR code'
    },
    configScanner: {
        title: 'Configuration QR',
        notConfig: 'Unrecognized configuration code',
        loggedIn: 'Logged in:',
        setsSelected: 'Selected ticketsets:',
        zonesSelected: 'Selected zone:',
        loginRequiredTitle: 'Login required',
        loginRequiredMessage: 'You need to log in before loading ticketsets or zones.',
        ok: 'OK'
    },
    event: {
        chooseEvent: 'Odaberi događaj',
        chooseEventPast: 'Prošli događaji',
        confirm: 'Potvrdi odabir događaja',
        showPast: 'prikaži prošle'
    },
    zone: {
        chooseZone: 'Odaberi zonu / zone',
        confirm: 'Potvrdi odabir zona'
    },
    ticketsets: {
        chooseTicketsets: 'Odaberi setove ulaznica',
        selectAll: 'Odaberi sve',
        ticketCount: 'Broj ulaznica:'
    },
    scanner: {
        tickets: 'Ulaznice:',
        startReader: 'Pokreni čitač',
        startReaderDescription:
            'Preglednik treba interakciju korisnika za reprodukciju sistemskih zvukova. Potvrdite tipkom "OK".',
        specialWarning: 'Upozorenje',
        specialType: 'Ulaznica posebnog tipa:',
        refuse: 'Odbij',
        confirm: 'Potvrdi',
        messageSuccess: 'Kod {code} prihvaćen',
        messageSuccessPrice: 'Kod {code} prihvaćen<br /><big>Cijena: <b>{price}</b></big>',
        messageSuccessTicketsetPrice: 'Kod {code} prihvaćen<br /><big>Set: <b>{ticketset} / {price}</b></big>',
        messageSuccessTicketset: 'Kod {code} prihvaćen<br /><big>Set: <b>{ticketset}</b></big>',
        messageSuccessEvent: 'Kod {code} prihvaćen<br /><big>Događaj: <b>{event}</b>, set: {ticketset}</big>',
        messageSuccessNosend: 'Kod {code} prihvaćen (nije poslano)',
        messageRead: 'Kod {code} pročitan',
        messageUsed: 'Kod {code} već iskorišten',
        messageNotUsable: 'Kod {code} se ne može koristiti',
        messageUnsend: 'Kod {code} već iskorišten (mojom, nije poslano)',
        messageNotFound: 'Kod <b>{code}</b> nije pronađen',
        messageBadSlot: 'Kod {code} nije valjan za ovu zonu/slot',
        messageExtra1: 'iskorišten na uređaju: <b>{device}</b>, datum: <b>{date}</b>',
        manualTitle: 'Ručni unos koda',
        loading: 'učitavanje ulaznica...',
        nfcNotFound: 'Nijedna ulaznica na kartici nije valjana'
    },
    login: {
        title: 'Prijava u aplikaciju',
        username: 'Korisničko ime',
        password: 'Lozinka',
        login: 'Prijavi se'
    },
    settings: {
        title: 'Postavke',
        sound: 'Zvuk',
        soundSub: 'Uključi zvučne obavijesti',
        camera: 'Kamera',
        nfc_heading: 'NFC',
        nfc: 'Čitaj NFC oznake',
        language: 'Jezik',
        langCs: 'Češki',
        langEn: 'Engleski',
        langDe: 'Njemački',
        langHr: 'Hrvatski',
        langHu: 'Mađarski',
        langPl: 'Poljski',
        langSk: 'Slovački',
        qTitle: 'Napredne postavke kamere',
        qPatchSize: 'Veličina prozora dekodiranja',
        qFrequency: 'Frekvencija dekodiranja',
        groupDisplay: 'Prikaži ime grupe / kategorije pri kontroli',
        groupDisplayNone: 'Ne prikazuj ništa',
        groupDisplayTicketset: 'Prikaži ime seta',
        groupDisplayTicketsetPrice: 'Prikaži set i cijenu',
        groupDisplayPrice: 'Prikaži cijenu',
        groupDisplayEvent: 'Prikaži događaj i set',
        olderEvents: 'Koliko dugo prikazivati starije događaje nakon isteka',
        olderEventsWeek: 'Tjedan',
        olderEventsMonth: 'Mjesec',
        olderEvents3Month: '3 mjeseca',
        olderEvents6Month: '6 mjeseci',
        olderEventsYear: '1 godina',
        olderEventsAll: 'Prikaži sve',
        olderEventsAllList: 'sve',
        showTicketCount: 'Prikaži broj ulaznica',
        showStatistics: 'Prikaži statistiku',
        queueTitle: 'Popis kodova u redu za slanje',
        queueSending: 'slanje u tijeku',
        queueYes: 'DA',
        queueNo: 'NE',
        queueEmpty: 'Red je prazan'
    },
    statistics: {
        title: 'Statistika korištenja ulaznica',
        zone: 'Zona',
        today: 'Danas',
        total: 'Ukupno',
        refresh: 'Osvježi podatke'
    },
    verify: {
        title: 'Provjera ulaznice',
        enterCode: 'Unesite kod ulaznice',
        verify: 'Provjeri',
        scanHint: 'Skenirajte kod ili unesite ručno',
        notFound: 'Ulaznica nije pronađena',
        found: 'Ulaznica pronađena',
        email: 'E-mail',
        entries: 'Ulazaka',
        people: 'Osoba',
        entryPause: 'Razmak ulaza (min)',
        purchased: 'Kupljeno',
        validUntil: 'Vrijedi do',
        event: 'Događaj',
        ticketset: 'Set ulaznica',
        price: 'Cjenovni razred',
        zones: 'Zone',
        noZones: 'Ulaznica nije dodijeljena nijednoj zoni.',
        slots: 'Slotovi',
        noSlots: 'Ulaznica nije dodijeljena nijednom slotu.',
        usageForZone: 'Korištenje u zoni',
        remains: 'Preostalo',
        usageLogs: 'Zapis korištenja ulaznica',
        showDebug: 'Q',
        debugQuery: 'Query',
        debugData: 'Data',
        newSearch: 'Nova provjera'
    }
} as const
